export default __webpack_public_path__ + "static/media/tpc_ownr.f68ec47a.svg";